import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M6.99348 14L11.6558 9.06347L6.99348 4.12694L5.89317 5.29196L8.70922 8.25388H1.56654V0H0V9.87306H8.70922L5.89317 12.835L6.99348 14Z",
  fill: "#D5D5D5"
})), 'ArrowDownRight');